// Project time on a custom-report row. A day split over two tickets repeats the same Start /
// Ende / Pause on both, so deriving it from the day span counted that day twice.

/** "HH:MM" → minutes, or null when the text is not a valid duration. */
export function parseHhmm(value) {
    const match = String(value ?? '').trim().match(/^(\d{1,3}):(\d{1,2})$/);
    if (!match) return null;
    const minutes = Number(match[2]);
    if (minutes > 59) return null;
    return Number(match[1]) * 60 + minutes;
}

/** Minutes as "HH:MM", the shape the PDF prints. */
export function formatHhmm(minutes) {
    const total = Math.max(0, Math.round(Number(minutes) || 0));
    return `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
}

/** The row's work day in minutes, never negative. Mirrors the backend's `calc_work_time`, which
 *  a report saved before the project time existed still falls back to. */
export function spanMinutes(entry) {
    const start = parseHhmm(entry?.startTime);
    const end = parseHhmm(entry?.endTime);
    if (start === null || end === null) return 0;
    return Math.max(0, end - start - (Number(entry?.breakMinutes) || 0));
}

/** The row's project time in minutes. Null means "let the backend fall back", not zero. */
export function rowProjectMinutes(entry) {
    return parseHhmm(entry?.projectTime);
}

/** Sum of a user's rows. An unusable value counts as zero, so the total survives typing. */
export function totalProjectMinutes(entries) {
    return (entries || []).reduce((sum, e) => sum + (rowProjectMinutes(e) ?? 0), 0);
}
